export default "__VITE_ASSET__DPqWWPad__"